import React from 'react';
import { paletaAzulJuridica } from '../../config/theme';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primaria', 
  className = '', 
  icon: Icon, 
  type = "button", 
  disabled = false,
  size = 'md',
  loading = false
}) => {
  const baseStyles = "flex items-center justify-center font-medium shadow-sm transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const sizeStyles = {
    sm: "px-3 py-1.5 text-sm rounded-md",
    md: "px-4 py-2 text-sm rounded-lg",
    lg: "px-6 py-3 text-base rounded-lg",
    xl: "px-8 py-4 text-lg rounded-xl"
  };
  
  const variantStyles = {
    primaria: "bg-juridica-primaria hover:bg-blue-800 text-white focus:ring-juridica-realce",
    secundaria: "bg-juridica-secundaria hover:bg-blue-600 text-white focus:ring-juridica-realce",
    outline: "border border-juridica-primaria text-juridica-primaria hover:bg-blue-50 focus:ring-juridica-realce",
    ghost: "text-juridica-primaria hover:bg-blue-50 focus:ring-juridica-realce",
    danger: "bg-red-600 hover:bg-red-700 text-white focus:ring-red-500",
    success: "bg-green-600 hover:bg-green-700 text-white focus:ring-green-500",
    warning: "bg-yellow-600 hover:bg-yellow-700 text-white focus:ring-yellow-500"
  };

  const LoadingSpinner = () => (
    <svg className="animate-spin -ml-1 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  );

  return (
    <button 
      type={type} 
      onClick={onClick} 
      disabled={disabled || loading} 
      className={`${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} ${className}`}
    >
      {loading && <LoadingSpinner />}
      {!loading && Icon && <Icon size={18} className="mr-2" />}
      {children}
    </button>
  );
};

export { Button };
export default Button;
